import React from "react";
import { Button, Typography } from "@material-ui/core";
import { HeartbeatChart } from "components/HeartbeatChart";

export class TheChart extends React.Component {
  constructor(props) {
    super(props);
    this.onFetchData = this.onFetchData.bind(this);
    this.state = { refreshKey: 0 };
  }

  onFetchData() {
    this.setState((state) => ({ refreshKey: state.refreshKey + 1 }));
  }

  render() {
    const { tenant_id, tenant_name, compact = true, height = 180, days = 7 } = this.props;
    return (
      <div className={compact ? 'superadmin-heartbeat-chart' : undefined}>
        <div className="superadmin-heartbeat-chart__toolbar">
          <Button variant="outlined" size="small" onClick={this.onFetchData}>Refresh</Button>
        </div>
        <HeartbeatChart
          key={`${tenant_id}-${this.state.refreshKey}`}
          tenantId={tenant_id}
          tenantName={tenant_name}
          days={days}
          height={height}
          compact={compact}
        />
        <Typography color="textSecondary" variant="caption" className="superadmin-heartbeat-chart__caption">
          Times shown in your local timezone (UTC stored server-side).
        </Typography>
      </div>
    );
  }
}
